import * as React from 'react'
import { useTooltip } from '@shared/ui/Overlays/Tooltip/hooks'

type ContextType = ReturnType<typeof useTooltip> | null

export const TooltipContext = React.createContext<ContextType>(null)
